import React, { useEffect, useState } from "react";

import { Col, Form, Row } from "react-bootstrap";

import Modal from "react-bootstrap/Modal";
import SimpleButton from "~/pages/Easypay/components/SimpleButton";
import Dropdown from "~/components/Dropdown";

const ModalNewProvider = ({
  isClicked,
  isClosed,
  takeNewProvider,
  companiesList,
}) => {
  const [isModalNewClientShowing, setIsModalNewClientShowing] = useState(false);

  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [dropdownInvalid, setDropdownInvalid] = useState(false);

  const setField = (field, value) => {
    setForm({
      ...form,
      [field]: value,
    });

    if (!!errors[field]) {
      setErrors({
        ...errors,
        [field]: null,
      });
    }
  };

  useEffect(() => {
    if (isClicked) {
      setIsModalNewClientShowing(true);
    }
  }, [isClicked]);

  const validateForm = () => {
    const { nome, morada, orgId, prazoPagamento, year } = form;
    const newErrors = {};
    if (!nome || nome === "" || !isNaN(nome)) {
      newErrors.nome = "Por favor preencha o nome";
    }
    if (!morada || morada === "" || !isNaN(morada)) {
      newErrors.morada = "Por favor preencha a morada.";
    }

    if (!orgId || orgId === "" || isNaN(orgId)) {
      newErrors.orgId = "Por favor preencha o ID da Organização.";
    }

    if (!year || year === "" || isNaN(year)) {
      newErrors.year = "Por favor preencha o ano.";
    }

    if (!prazoPagamento || prazoPagamento === "" || isNaN(prazoPagamento)) {
      newErrors.prazoPagamento = "Por favor preencha o prazo de pagamento.";
    }

    return newErrors;
  };

  const handleClose = () => setIsModalNewClientShowing(false);

  useEffect(() => {
    isClosed(isModalNewClientShowing);
  }, [isModalNewClientShowing]);

  const handleSaveData = () => {
    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      setDropdownInvalid(true);
    } else {
      setDropdownInvalid(false);
      takeNewProvider(form);
      handleClose();
      setForm("");
    }
  };

  const handleDropdownClassName = (varError, boolean) => {
    if (boolean) {
      return (
        "dropdown-margin " +
        (varError === "" || varError === undefined
          ? "dropdown-border-invalid"
          : "")
      );
    }
  };

  return (
    <>
      <Modal show={isModalNewClientShowing} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Novo Fornecedor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              <Col xl="12" md="12">
                <Form.Label>Nome</Form.Label>
                <Form.Control
                  value={form.nome || ""}
                  onChange={(e) => setField("nome", e.target.value)}
                  type="text"
                  isInvalid={!!errors.nome}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.nome}
                </Form.Control.Feedback>
              </Col>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              <Col xl="12" md="12">
                <Form.Label>Morada</Form.Label>
                <Form.Control
                  value={form.morada || ""}
                  onChange={(e) => setField("morada", e.target.value)}
                  type="text"
                  isInvalid={!!errors.morada}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.morada}
                </Form.Control.Feedback>
              </Col>
            </div>

            <div style={{ display: "flex", flexWrap: "wrap" }}>
              <Col xl="6" md="6">
                <Form.Label>Empresa</Form.Label>
                <Dropdown
                  list={companiesList}
                  handleSubmit={(e) => setField("orgId", e)}
                  className={handleDropdownClassName(
                    form.orgId,
                    dropdownInvalid
                  )}
                />
                <div
                  style={{
                    width: "100%",
                    fontSize: "80%",
                    color: "#dc3545",
                  }}
                >
                  {errors.orgId}
                </div>
              </Col>

              <Col xl="6" md="6">
                <Form.Label>Ano</Form.Label>
                <Form.Control
                  value={form.year || ""}
                  onChange={(e) => setField("year", e.target.value)}
                  type="text"
                  isInvalid={!!errors.year}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.year}
                </Form.Control.Feedback>
              </Col>
            </div>

            <div style={{ display: "flex", flexWrap: "wrap" }}>
              <Col xl="12" md="12">
                <Form.Label>Prazo do Pagamento</Form.Label>
                <Form.Control
                  value={form.prazoPagamento || ""}
                  onChange={(e) => setField("prazoPagamento", e.target.value)}
                  type="text"
                  isInvalid={!!errors.prazoPagamento}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.prazoPagamento}
                </Form.Control.Feedback>
              </Col>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-around",
            paddingTop: "15px",
          }}
        >
          <SimpleButton
            text={"Fechar"}
            variant={"liftworld-button-primary"}
            onClick={handleClose}
          />
          <SimpleButton
            text={"Guardar"}
            variant={"liftworld-button-primary"}
            onClick={handleSaveData}
          />
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ModalNewProvider;
